import { getSubdomain } from 'helpers/global';
import { useSelector } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';

function SubscriptionFooter() {
  const { isWhiteLabelCompany, isLoadingWhiteLabel } = useSelector((state) => state.whiteLabel);

  return (
    <>
      <footer className="footer py-5">
        <Container>
          <Row className="align-items-center justify-content-xl-between">
            {(!getSubdomain() || (!isLoadingWhiteLabel && !isWhiteLabelCompany)) && (
              <Col xl="6">
                <div className="copyright text-center text-xl-left text-black">
                  © {new Date().getFullYear()}{' '}
                  <span className="font-weight-bold text-brand">Gather</span>
                </div>
              </Col>
            )}
          </Row>
        </Container>
      </footer>
    </>
  );
}

export default SubscriptionFooter;
